import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const RotateLeft = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='RotateLeft' {...props}>
    <path d='M11.52,3.43A9.09,9.09,0,0,0,5.7,5.55V2.35H4.07v6.5h6.5V7.21H6.3a7.46,7.46,0,1,1-1.47,8.65l-1.46.73A9.11,9.11,0,1,0,11.52,3.43Z' />
  </StyledIcon>
);
